import React from 'react';
import { Card, Grid, Divider, Button, Item } from 'semantic-ui-react';
import ClaimSummary from '../../ClaimSummary';
import PathView from '../../PathView';
import Content from '../../Content';
import TaskContainer from '../../TaskContainer';
import LitigationModal from '../../modals/LitigationModal';
import getTaskTitle from '../../../utils/getTaskTitle';
import { dateFormat, dateTimeFormat } from '../../../utils/dateFormat';

const TaskView = ({
  task,
  claim,
  loading,
  onTaskUpdate,
  litigationModalOpen,
  onLitigationModalOpen,
  onLitigationModalClose,
  onClaimClosed,
  onRemind,
  onClose
}) => {
  const {
    crmState,
    airlineAgreementDate,
    airlineAgreementAmount,
    courtName,
    courtHearingAt,
    lawyer
  } =
    claim || '';
  const lawyerFullName = lawyer ? `${lawyer.name} ${lawyer.surname}` : '';
  const { id, createdAt, priority } = task || '';

  return (
    <Content fullWidth>
      <PathView
        paths={[
          { name: 'Tasks', path: '/tasks' },
          { name: id, path: `/task/${id}` }
        ]}
      />
      <TaskContainer
        title={getTaskTitle(task)}
        date={createdAt}
        id={id}
        priority={priority}
        icon="hashtag"
        claimId={claim ? claim.id : ''}
        loading={loading}
        hideClaim={false}
        onClaimClosed={onClaimClosed}
        hideCloseClaimBtn
      >
        <LitigationModal
          open={litigationModalOpen}
          dimmer={true}
          hideModal={onLitigationModalClose}
          taskId={id}
          claimId={claim ? claim.id : ''}
        />
        <Card.Description>
          <Grid>
            <Grid.Row>
              <Grid.Column width={5}>
                <ClaimSummary claim={claim} />
              </Grid.Column>
              {(crmState === 'c6_litigation_pending_payment_reminder1' ||
                crmState === 'c6_litigation_pending_payment_reminder2') && (
                  <Grid.Column width={11}>
                    <Grid>
                      <Grid.Row>
                        <Grid.Column>
                          <Item.Meta>Agreement from airline date</Item.Meta>
                          <Item.Description>
                            {dateFormat(airlineAgreementDate)}
                          </Item.Description>
                          <br />
                          <Item.Meta>Agreement from airline amount</Item.Meta>
                          <Item.Description>
                            {airlineAgreementAmount}
                          </Item.Description>
                          <br />
                          <Item.Meta>Court name</Item.Meta>
                          <Item.Description>{courtName}</Item.Description>
                          <br />
                          <Item.Meta>Court hearing date</Item.Meta>
                          <Item.Description>
                            {dateTimeFormat(courtHearingAt)}
                          </Item.Description>
                          <br />
                          <Item.Meta>Lawyer</Item.Meta>
                          <Item.Description>{lawyerFullName}</Item.Description>
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  </Grid.Column>
                )}
            </Grid.Row>
          </Grid>
        </Card.Description>
        <Divider hidden />
        <Card.Content>
          {crmState !== 'b3_waiver_call_reminder' && (
            <Button
              floated="right"
              primary
              onClick={onRemind}
              content="Reminder"
            />
          )}
          <Button
            floated="right"
            color="red"
            onClick={onClose}
            content="Close Claim"
          />
          {crmState === 'b1_questions_call_reminder1' && (
            <Button
              floated="right"
              primary
              onClick={onLitigationModalOpen}
              content="Litigation"
            />
          )}
        </Card.Content>
      </TaskContainer>
    </Content>
  );
};

export default TaskView;



// WEBPACK FOOTER //
// ./src/component/tasks/CheckClaimBeforeClosureTask/TaskView.js